import type { InternalAxiosRequestConfig } from "axios";
import type { InterceptorConfig } from "../../createApi.ts";
import { InterceptorType } from "../../createApi.ts";

export function JwtBearerTokenRequestInterceptor(
  tokenGetter: () => string,
  skip?: (config: InternalAxiosRequestConfig) => boolean,
): InterceptorConfig<InterceptorType.REQUEST> {
  async function resolved(config: InternalAxiosRequestConfig<any>): Promise<InternalAxiosRequestConfig> {
    if (!config.url) {
      return config;
    }

    if (skip?.(config)) {
      return config;
    }

    // Signed out there is no token: an empty `Bearer ` is a failed authentication to the API (401 even on public
    // routes such as the integrations app lookup), while no header at all is an anonymous request.
    const token = tokenGetter();
    if (!token) {
      return config;
    }

    config.headers.Authorization = `Bearer ${token}`;

    return config;
  }

  return {
    name: "JwtBearerTokenRequestInterceptor",
    type: InterceptorType.REQUEST,
    priority: 100,
    resolved,
  };
}
